import InboundFilters from './inbound-filters';
import { IntentFilteringContent } from './intent-filtering';
import { ChannelFilteringTab, OperatingHoursTab, SkipHumanAssignedRow, TagFilteringTab } from './operating-hours';
import { TabsContent } from '@/components/ui/tabs';
import { SettingsBody, SettingsPage, useTabParam, type SettingsTab } from '@/modules/settings';

type IngestionTab = 'inbound' | 'channels' | 'tags' | 'intents' | 'operating-hours';

const TABS: SettingsTab<IngestionTab>[] = [
	{ value: 'inbound', label: 'Inbound' },
	{ value: 'channels', label: 'Channels' },
	{ value: 'tags', label: 'Tags' },
	{ value: 'intents', label: 'Intents' },
	{ value: 'operating-hours', label: 'Operating Hours' }
];

const CONTENT_CLASS = 'mt-0 flex flex-1 flex-col';

/** Settings › Ingestion: which tickets reach Kim at all. `?tab=` opens a tab directly. */
export default function IngestionPage() {
	const [tab, setTab] = useTabParam(TABS, 'inbound');
	return (
		<SettingsPage title='Ingestion' tabs={TABS} tab={tab} onTabChange={setTab}>
			<TabsContent value='inbound' className={CONTENT_CLASS}>
				<SettingsBody>
					<InboundFilters>
						<SkipHumanAssignedRow />
					</InboundFilters>
				</SettingsBody>
			</TabsContent>
			<TabsContent value='channels' className={CONTENT_CLASS}>
				<ChannelFilteringTab />
			</TabsContent>
			<TabsContent value='tags' className={CONTENT_CLASS}>
				<TagFilteringTab />
			</TabsContent>
			<TabsContent value='intents' className={CONTENT_CLASS}>
				<SettingsBody>
					<IntentFilteringContent />
				</SettingsBody>
			</TabsContent>
			<TabsContent value='operating-hours' className={CONTENT_CLASS}>
				<OperatingHoursTab />
			</TabsContent>
		</SettingsPage>
	);
}
